const Act2021 = [
  {
    path: '/keysight210119/index',
    name: 'keysight210119',
    component: resolve => require(['@/act2021/keysight210119/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210119/download',
    name: 'keysight210119Download',
    component: resolve => require(['@/act2021/keysight210119/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/keysight210126/index',
    name: 'keysight210126',
    component: resolve => require(['@/act2021/keysight210126/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210126/download',
    name: 'keysight210126Download',
    component: resolve => require(['@/act2021/keysight210126/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/newpeople/index',
    name: 'newpeople',
    component: resolve => require(['@/act2021/newpeople210223/index'], resolve),
    meta: {
      title: 'VIP会员福利'
    }
  },
  {
    path: '/newpeople/form',
    name: 'newpeopleForm',
    component: resolve => require(['@/act2021/newpeople210223/form'], resolve),
    meta: {
      title: 'VIP会员完善信息'
    }
  },
  {
    path: '/newpeople/finish',
    name: 'newpeopleFinish',
    component: resolve => require(['@/act2021/newpeople210223/finish'], resolve),
    meta: {
      title: 'VIP会员申请成功'
    }
  },
  {
    path: '/newpeople_live_activity/index',
    name: 'newpeopleActivity',
    component: resolve => require(['@/act2021/newpeopleAct210302/index'], resolve),
    meta: {
      title: '直播活动'
    }
  },
  {
    path: '/newpeople_live_activity/select',
    name: 'newpeopleActivitySelect',
    component: resolve => require(['@/act2021/newpeopleAct210302/select'], resolve),
    meta: {
      title: '直播活动-选择奖品'
    }
  },
  {
    path: '/newpeople_live_activity/submit',
    name: 'newpeopleActivitySubmit',
    component: resolve => require(['@/act2021/newpeopleAct210302/submit'], resolve),
    meta: {
      title: '直播活动-兑换奖品'
    }
  },
  {
    path: '/keysight210308/index',
    name: 'keysight210308',
    component: resolve => require(['@/act2021/keysight210308/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210308/download',
    name: 'keysight210308Download',
    component: resolve => require(['@/act2021/keysight210308/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/keysight210406/index',
    name: 'keysight210406',
    component: resolve => require(['@/act2021/keysight210406/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210406/download',
    name: 'keysight210406Download',
    component: resolve => require(['@/act2021/keysight210406/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/keysight210512/index',
    name: 'keysight210512',
    component: resolve => require(['@/act2021/keysight210512/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210512/download',
    name: 'keysight210512Download',
    component: resolve => require(['@/act2021/keysight210512/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/tektronix210616/index',
    name: 'tektronix210616Index',
    component: resolve => require(['@/act2021/tektronix210616/index'], resolve),
    meta: {
      title: 'Tektronix第二代IsoVu光隔离高压探头'
    }
  },
  {
    path: '/keysight210715/index',
    name: 'keysight210715',
    component: resolve => require(['@/act2021/keysight210715/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210715/download',
    name: 'keysight210715Download',
    component: resolve => require(['@/act2021/keysight210715/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/keysight210812/index',
    name: 'keysight210812',
    component: resolve => require(['@/act2021/keysight210812/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight210812/download',
    name: 'keysight210812Download',
    component: resolve => require(['@/act2021/keysight210812/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/keysight210905/index',
    name: 'keysight210905',
    component: resolve => require(['@/act2021/keysight210905/index.vue'], resolve),
    meta: {
      title: '是德远程教学实验室'
    }
  },
  {
    path: '/keysight210905/questionnaire',
    name: 'keysight210905questionnaire',
    component: resolve => require(['@/act2021/keysight210905/questionnaire.vue'], resolve),
    meta: {
      title: '是德远程教学实验室-问卷'
    }
  },
  {
    path: '/keysight210906/index',
    name: 'keysight210906',
    component: resolve => require(['@/act2021/keysight210906/index.vue'], resolve),
    meta: {
      title: '是德远程教学实验室'
    }
  },
  {
    path: '/keysight210906/questionnaire',
    name: 'keysight210906',
    component: resolve => require(['@/act2021/keysight210906/questionnaire.vue'], resolve),
    meta: {
      title: '是德远程教学实验室-问卷'
    }
  },
  {
    path: '/keysight210906/godraw',
    name: 'keysight210906',
    component: resolve => require(['@/act2021/keysight210906/godraw.vue'], resolve),
    meta: {
      title: '是德远程教学实验室-去抽奖'
    }
  },
  {
    path: '/single210819/index',
    name: 'single210819',
    component: resolve => require(['@/act2021/single210819/index'], resolve),
    meta: {
      title: '报名成功' // live page 报名成功
    }
  },
  {
    path: '/vicor210913/index',
    name: 'vicor210913',
    component: resolve => require(['@/act2021/vicor210913/index.vue'], resolve),
    meta: {
      title: 'vicor无人机领域产业调研'
    }
  },
  {
    path: '/vicor210913/questionnaire',
    name: 'vicor210913',
    component: resolve => require(['@/act2021/vicor210913/questionnaire.vue'], resolve),
    meta: {
      title: 'vicor无人机领域产业调研-问卷'
    }
  },
  {
    path: '/vicor210913/godraw',
    name: 'vicor210913',
    component: resolve => require(['@/act2021/vicor210913/godraw.vue'], resolve),
    meta: {
      title: 'vicor无人机领域产业调研-去抽奖'
    }
  },
  {
    path: '/mps211013/index/:page_identify?',
    name: 'mps211013',
    component: resolve => require(['@/act2021/mps211013/index.vue'], resolve),
    meta: {
      title: '2021MPS工业和家电电源技术研讨会'
    }
  },
  {
    path: '/mps211016/index/:page_identify?',
    name: 'mps211016',
    component: resolve => require(['@/act2021/mps211016/index.vue'], resolve),
    meta: {
      title: '2021MPS工业和家电电源技术研讨会'
    }
  },
  {
    path: '/keysight211025/index',
    name: 'keysight211025',
    component: resolve => require(['@/act2021/keysight211025/index.vue'], resolve),
    meta: {
      title: '参与是德问卷，获取演讲资料'
    }
  },
  {
    path: '/keysight211025/download',
    name: 'keysight211025Download',
    component: resolve => require(['@/act2021/keysight211025/download'], resolve),
    meta: {
      title: 'keysight直播演讲资料下载'
    }
  },
  {
    path: '/mps211103/index/:page_identify?',
    name: 'mps211103',
    component: resolve => require(['@/act2021/mps211103/index.vue'], resolve),
    meta: {
      title: '微功率隔离电源模块应用与设计'
    }
  },
  {
    path: '/mps211110/index/:page_identify?',
    name: 'mps211103',
    component: resolve => require(['@/act2021/mps211110/index.vue'], resolve),
    meta: {
      title: 'AI电源解决方案'
    }
  },
  {
    path: '/adi211215/index/:page_identify?',
    name: 'adi211215',
    component: resolve => require(['@/act2021/adi211215/index.vue'], resolve),
    meta: {
      title: '活动'
    }
  }
]

export default Act2021
